<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：中华人民共和国住房和城乡建设部网站）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入名称"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              clearable
              v-model="state"
              placeholder="省份"
              class="sele"
              @change="stateChange"
            >
              <el-option
                v-for="item in stateList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>

            <el-select
              clearable
              v-model="nature"
              placeholder="批次"
              class="sele"
              @change="natureChange"
            >
              <el-option
                v-for="item in natureList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              v-if="this.$route.query.type == 'cityName'"
              align="center"
              prop="cityName"
              label="名称"
              min-width="450px"
            >
            </el-table-column>
            <el-table-column
              v-if="this.$route.query.type == 'streetName'"
              align="center"
              prop="streetName"
              label="名称"
              min-width="450px"
            >
            </el-table-column>
            <el-table-column
              v-if="this.$route.query.type == 'townName'"
              align="center"
              prop="townName"
              label="名称"
              min-width="450px"
            >
            </el-table-column>
            <el-table-column
              v-if="this.$route.query.type == 'villageName'"
              align="center"
              prop="villageName"
              label="名称"
              min-width="450px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="districtCodeName"
              label="省份"
              min-width="268px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="batchNumName"
              label="批次"
              min-width="268px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_DATA_HISTORY,
  URL_MING_STREET_INTERFACE,
  URL_MINGCUN_INTERFACE,
  URL_MINGZHEN_INTERFACE,
  URL_COMPREHENSIVE_EXCUSE,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "",
        // 浏览次数
        num: "2",
      },
      //   省份
      stateList: [],
      //   批次
      natureList: [],
      //省份
      state: null,
      //批次
      nature: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 分页表格数据
      schArr: [],
      // 前往页数
      currentPage: 1,
      // 条数
      pagesize: 20,
      total: 0,
    };
  },
  computed: {},
  methods: {
    // 请求数据
    getList() {
      let result = frontHeater(
        ["batchNum", "districtCode"],
        [this.nature, this.state]
      );
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pagesize,
        keyWord: this.searchOn,
        batchNum: this.nature,
        districtCode: this.state,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["batchNum"] = this.nature;
      this.$http.defaults.headers.common["districtCode"] = this.state;
      if (this.$route.query.type == "cityName") {
        this.$http.post(Url + URL_DATA_HISTORY, params).then((resp) => {
          if (resp.status === 200) {
            this.legalForms = resp.data.data;
            this.total = resp.data.recordsTotal;
          }
        });
      }
      if (this.$route.query.type == "streetName") {
        this.$http
          .post(Url + URL_MING_STREET_INTERFACE, params)
          .then((resp) => {
            if (resp.status === 200) {
              this.legalForms = resp.data.data;
              this.total = resp.data.recordsTotal;
            }
          });
      }
      if (this.$route.query.type == "townName") {
        this.$http.post(Url + URL_MINGZHEN_INTERFACE, params).then((resp) => {
          if (resp.status === 200) {
            this.legalForms = resp.data.data;
            this.total = resp.data.recordsTotal;
          }
        });
      }
      if (this.$route.query.type == "villageName") {
        this.$http.post(Url + URL_MINGCUN_INTERFACE, params).then((resp) => {
          if (resp.status === 200) {
            this.legalForms = resp.data.data;
            this.total = resp.data.recordsTotal;
          }
        });
      }
    },
    // 获取省份
    getProvinceList() {
      let result = frontHeater(["ClassCode"], ["DistrictCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "DistrictCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "DistrictCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.stateList = res.data.data;
        }
      });
    },
    //获取批次
    getBatchList() {
      let result = frontHeater(["ClassCode"], ["TownBatchNum"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "TownBatchNum",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "TownBatchNum";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.natureList = res.data.data;
        }
      });
    },
    // 获取浏览次数
    getNumberViews() {
      let Url = util.getAjaxUrl("axiosTWo");
      if (this.$route.query.type == "cityName") {
        let result = frontHeater(["dataType"], ["DataHistoryCity"]);
        let params = {
          dataType: "DataHistoryCity",
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.defaults.headers.common["dataType"] = "DataHistoryCity";
        this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
          if (res.status === 200) {
            this.regulations.num = res.data.data.viewTimes;
          }
        });
      }
      if (this.$route.query.type == "streetName") {
        let result = frontHeater(["dataType"], ["DataHistoryStreet"]);
        let params = {
          dataType: "DataHistoryStreet",
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.defaults.headers.common["dataType"] = "DataHistoryStreet";
        this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
          if (res.status === 200) {
            this.regulations.num = res.data.data.viewTimes;
          }
        });
      }
      if (this.$route.query.type == "townName") {
        let result = frontHeater(["dataType"], ["DataHistoryTown"]);
        let params = {
          dataType: "DataHistoryTown",
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.defaults.headers.common["dataType"] = "DataHistoryTown";
        this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
          if (res.status === 200) {
            this.regulations.num = res.data.data.viewTimes;
          }
        });
      }
      if (this.$route.query.type == "villageName") {
        let result = frontHeater(["dataType"], ["DataHistoryVillage"]);
        let params = {
          dataType: "DataHistoryVillage",
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.defaults.headers.common["dataType"] = "DataHistoryVillage";
        this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
          if (res.status === 200) {
            this.regulations.num = res.data.data.viewTimes;
          }
        });
      }
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.state = null;
      this.nature = null;
      this.currentPage = 1;
      this.pagesize = 20;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },

    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    stateChange() {
      this.getList();
    },
    natureChange() {
      this.getList();
    },
  },
  mounted() {
    this.regulations.laws = this.$route.query.title;
    this.getList();
    this.getProvinceList();
    this.getBatchList();
    this.getNumberViews();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}

.sele {
  width: 170px;
  height: 32px;
  margin: 10px 0;
}
.dat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  // margin-bottom: 10px;
}
/deep/.el-input--suffix .el-input__inner {
  height: 32px;
  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all 0.3s;
    line-height: 30px;
  }
}
</style>